import React from "react";
import "../../Styles/yellowcalf.css/Collection_Report.css";

function Collection_Report() {
  return (
    <div className="collection-report-container" style={{ paddingTop: "25px" }}>
      <div className="collection-report-header-section">
        <div className="collection-report-header-box">
          <h3 className="collection-report-header-title">Collection Report</h3>

          <div className="collection-report-export-section">
            <button className="collection-report-export-button">
              Export <i className="fa fa-angle-down"></i>
            </button>

            <ul className="collection-report-export-list">
              <li><a href="#">Save as PDF</a></li> 
            </ul>
          </div>
        </div>
      </div>

      <div className="collection-report-filter-section">
        <div className="collection-report-filter-row">
          <div className="collection-report-filter-item">
            <input
              type="date"
              id="startdate"
              className="collection-report-date-input"
              placeholder="Start Date"
            />
          </div>

          <div className="collection-report-filter-item">
            <input
              type="date"
              id="enddate"
              className="collection-report-date-input"
              placeholder="End Date"
            />
          </div>

          <div className="collection-report-filter-item">
            <button type="submit" className="collection-report-btn collection-report-btn-search">
              Search
            </button>
            <button type="reset" className="collection-report-btn collection-report-btn-clear">
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Collection_Report;
